<template>
  <div class="interaction letter fangkong">
    <!-- 互动交流写信 -->
    <!-- 内容区 -->
    <div class="content inner">
      <!-- 面包屑导航 -->
      <div class="mbnav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">
            <img class="homeIcon" src="/statics/image/index/home.png" alt />
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>专题专栏</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主任信箱 -->
      <div class="zrEmail">
        <div class="pic">
          <img class="homeIcon" src="/statics/image/index/fangkong.png" alt />
        </div>
        <div class="zr_con">
          <h3>疫情防控"接诉即办”专栏</h3>
          <p>
            （一）请认真填写表格（带<span class="hxing">*</span>为必填）（二）请留下您的真实姓名、联系电话、信箱地址、以便更好地与您联系！
          </p>
        </div>
      </div>
      <!-- 请埴写您的个人信息 -->
      <div class="opinion">
        <!-- 表 -->
        <div class="xin_table">
          <h3>请填写您的个人信息</h3>
          <div class="one">
            <div class="lett_name">
              <div class="lable">
                <span>姓名</span>
                <span class="hxing">*</span>
              </div>
              <el-input v-model="name" placeholder="请输入您的姓名"></el-input>
            </div>
            <div class="lett_tel">
              <div class="lable">
                <span>联系电话</span>
                <span class="hxing">*</span>
              </div>
              <el-input v-model="tel" placeholder="请输入您的联系电话"></el-input>
            </div>
            <div class="lett_email">
              <div class="lable">
                <span>电子邮箱</span>
              </div>
              <el-input v-model="email" placeholder="请输入您的电子邮箱"></el-input>
            </div>
          </div>
          <h3>请填写您的信件信息</h3>
          <div class="two">
            <div class="lable">
              <span>办件标题</span>
              <span class="hxing">*</span>
            </div>
            <el-input v-model="zhuti" placeholder="请输入您的办件标题"></el-input>
          </div>
          <div class="three">
            <div class="lable">
              <span>内容</span>
              <span class="hxing">*</span>
            </div>
            <el-input
              type="textarea"
              placeholder="请输入您的内容"
              v-model="textarea"
              maxlength="1000"
              show-word-limit
            ></el-input>
          </div>
          <div class="four">
            <div class="lable">
              <span>验证码</span>
              <span class="hxing">*</span>
            </div>
            <div class="yanzheng">
              <el-input v-model="yan" placeholder></el-input>
            </div>
            <div class="desc">
              <span>请填入右图中的字符：</span>
            </div>
            <div class="ma">
              <span @click="createCode">{{ checkCode}}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="xinbtn">
          <span class="chong" @click="toChong">重置</span>
          <span class="save" @click="toSave">保存</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "", //姓名
      tel: "", //联系电话
      email: "", //电子邮箱
      zhuti: "", //留言主题
      textarea: "", //留言
      yan: "", //验证码
      checkCode: "" //随机验证码
    };
  },
  created() {
    this.toChong();
    this.createCode();
  },
  methods: {
    // 生成验证码
    createCode() {
      let code = "";
      const codeLength = 4; //验证码的长度
      const random = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ); //随机数
      for (let i = 0; i < codeLength; i++) {
        //循环操作
        let index = Math.floor(Math.random() * 36); //取得随机数的索引（0~35）
        code += random[index]; //根据索引取得随机数加到code上
      }
      this.checkCode = code; //把code值赋给验证码
    },
    //   点击重置
    toChong() {
      this.name = "";
      this.tel = "";
      this.email = "";
      this.zhuti = "";
      this.textarea = "";
      this.yan = "";
      this.createCode();
    },
    //   点击保存
    toSave() {
      // console.log(this.name, this.tel, this.email, this.zhuti, this.textarea);
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)"
      });
      // setTimeout(() => {
      //   loading.close();
      // }, 2000);

      if (that.yan != that.checkCode) {
        that.$message({
          message: "验证码错误，注意大写字母",
          type: "warning"
        });
        loading.close();
        that.createCode();
        return false;
      }
      var ps = {
        name: that.name,
        title: that.zhuti,
        content: that.textarea,
        phone: that.tel,
        email: that.email
      };
      that.$api.index.posttousu(ps).then(function(res) {
        if (res.code == 200) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          setTimeout(function() {
            that.toChong();
            that.createCode();
            loading.close();
          }, 2000);
        }else{
           loading.close();
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.toChong();
    }
  }
};
</script>

<style scoped>
.hxing {
  color: #ff2323;
  margin-left: 0.02rem;
  font-size: 0.08rem;
  font-weight: 600;
}
.lable {
  display: flex;
  align-items: center;
}
</style>
<style>
.el-loading-mask .el-loading-spinner i {
  font-size: 0.3rem;
  color: #fff;
}
</style>